import { N10_01 } from "./N10_01";

export const N10 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Detailed Call Report",
    binding: {
      data: {
        columns: [
            {
                name: "Year",
                columnName: "Year",
                width: "100px",
                align: "left",
                sortable: true
            },
            {
                name: "Cycle",
                columnName: "Cycle",
                width: "120px",
                align: "center",
                sortable: true
            },
            {
                name: "Quarter",
                columnName: "Quarter",
                width: "120px",
                align: "center",
                sortable: true
            },
            {
                name: "Month",
                columnName: "Month",
                width: "160px",
                align: "center",
                sortable: true
            },
            {
                name: "Area Code",
                columnName: "AreaCode",
                width: "160px",
                align: "center",
                sortable: true
            },
            {
                name: "Area",
                columnName: "Area",
                width: "200px",
                align: "left",
                sortable: true
            },
            {
                name: "District Code",
                columnName: "DistrictCode",
                width: "200px",
                align: "center",
                sortable: true
            },
            {
                name: "District",
                columnName: "District",
                width: "300px",
                align: "left",
                sortable: true
            },
            {
                name: "DM Code",
                columnName: "DMCode",
                width: "150px",
                align: "center",
                sortable: true
            },
            {
                name: "DM",
                columnName: "DM",
                width: "220px",
                align: "left",
                sortable: true
            },
            {
                name: "TER Code",
                columnName: "AgentCode",
                width: "180px",
                align: "center",
                sortable: true
            },
            {
                name: "Territory",
                columnName: "Territory",
                width: "400px",
                align: "left",
                sortable: true
            },
            {
                name: "TER Name",
                columnName: "AgentName",
                width: "250px",
                align: "left",
                sortable: true
            }
        ],
        title: "AgentName",
        endpoint: "SFE_N10",
        parameters: [
          { key: "CycleCode", value: "CP1" },
          { key: "CycleYear", value: "2026" },
        ],
      },
      context: {
        point: {
          onClick: N10_01,
        },
      },
    },
  },
};
